import { type RefObject, useEffect, useRef, useState } from "react";

export function useOnScreenObserver<R extends Element>(ref: RefObject<R>) {
    const [isOnScreen, setIsOnScreen] = useState(false);
    const observerRef = useRef<IntersectionObserver | null>(null);

    useEffect(() => {
        observerRef.current = new IntersectionObserver(([entry]) =>
            setIsOnScreen(entry.isIntersecting),
        );
    }, []);

    useEffect(() => {
        if (observerRef.current && ref.current) {
            observerRef.current.observe(ref.current);
        }

        return () => {
            observerRef.current?.disconnect();
        };
    }, [ref]);

    return isOnScreen;
}
